import {
    SET_FORM_DATA_FROM_TABLE_OPERATION_TEAM_MASTER,
    SET_IS_EDITING_OPERATION_TEAM,
    SET_IS_CREATING_OPERATION_TEAM,
    SET_ALL_OPERATION_TEAMS
} from "../actions/types";

const initialState = {
    formDataFromTableOperationTeamMaster: {},
    isEditingOperationTeam: false,
    isCreatingOperationTeam: false,
    allOperationTeams: []
};

const OperationTeamMasterReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_FORM_DATA_FROM_TABLE_OPERATION_TEAM_MASTER:
            return { ...state, formDataFromTableOperationTeamMaster: payload };

        case SET_IS_EDITING_OPERATION_TEAM:
            return { ...state, isEditingOperationTeam: payload };

        case SET_IS_CREATING_OPERATION_TEAM:
            return { ...state, isCreatingOperationTeam: payload };
        case SET_ALL_OPERATION_TEAMS:
            return { ...state, allOperationTeams: payload}

        default:
            return state;
    }
};

export default OperationTeamMasterReducer;